import classNames from 'classnames';
import Sizing from '../../types/enum/Sizing';
import './ButtonGroup.scss';
import IButtonGroupProps from './ButtonGroupProps';

const ButtonGroup = ({ sizing, className, children }: IButtonGroupProps) => {
  const classes = classNames(
    {
      'btn-group': true,
      [`btn-group-${sizing}`]: true,
    },
    className
  );

  return <div className={classes}>{children}</div>;
};

ButtonGroup.defaultProps = {
  sizing: Sizing.FIXED,
};

export default ButtonGroup;
